export default "__VITE_PUBLIC_ASSET__363565a3__"